module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/Pages/purchase/purchase.component.css
// module id = ./src/app/Pages/purchase/purchase.component.css
// module chunks = main